import { CartPaymentLimitsInterface, RATE_LIMIT_VALUES } from '../interfaces/CartInterface'

export function parseRateLimitHeader(header: string): Partial<CartPaymentLimitsInterface> {
  const parsedHeader: Partial<CartPaymentLimitsInterface> = {}
  let valueStrParts
  header.split(', ').forEach(limit => {
    valueStrParts = limit.split('=')
    if (valueStrParts.length !== 2) {
      return
    }
    switch (valueStrParts[0]) {
      case RATE_LIMIT_VALUES.CARD:
        parsedHeader.card = parseInt(valueStrParts[1], 10)
        break
      case RATE_LIMIT_VALUES.PREPARE_ENROLLMENT:
        parsedHeader.prepareEnrolment = parseInt(valueStrParts[1], 10)
        break
      default:
    }
  })
  return parsedHeader
}
